import { IntroStep } from '../../../../core/services/tour.service';

export const studentIntroSteps: IntroStep[] = [
  {
    element: '#help-tour-btn',
    intro: 'Click here to take a tour of this page.'
  },
  {
    element: '.report-section-header',
    intro: 'The Student Summary is where you can view each student\'s usage and progress and performance data all in one location. This report can be shared with the student and/or their family.'
  },
  {
    element: '#student-dropdown',
    intro: 'Select a student from the dropdown to view their specific data.'
  },
  {
    element: '#hideSharedStudentsCheckBox',
    intro: 'Select this box to hide students who have been shared with you. Once enabled, the student list will only display those you are directly assigned to — excluding any students you\'re listed as a co-teacher for.'
  },
  {
    element: '#print-button',
    intro: 'Click here to print the Student Summary for the selected student.'
  },
  {
    element: '#batch-print-button',
    intro: 'Click here to batch print the Student Summary for all students or selected students.'
  },
  {
    element: '#student-usage-progress-wrapper',
    intro: 'See the student\'s usage and progress. This includes their current unit and level, their weekly minutes and levels completed for the current week, and their average weekly usage minutes.'
  },
  {
    element: '#student-performance-wrapper',
    intro: 'See the student\'s performance data. This includes Screener, Diagnostic, and Objective Pre and Posttest Results.',
    position: 'left',
  },
  {
    element: '#screenerResults',
    intro: 'See the three risk categories that students are sorted into: High Risk, Some Risk, and Proficient. See the student\'s Screener results. The WordFlight Screener estimates the student\'s performance on the WordFlight Diagnostic, which has a scale of 0 to 600. Screener results are presented in a confidence interval of 60 scale points.'
  },
  {
    element: '#diagnosticResults',
    intro: 'See the student\'s Diagnostic Results for the Pre-, Mid-, and Post-Diagnostic. Students in grades 5 and above will have both a Word Recognition and Decoding score. Students in grades 2–4 will only have a Word Recognition score. Students take the Diagnostic before Unit 1, after Unit 12, and after Unit 24.'
  },
  {
    element: '#diagnostic-button',
    intro: 'Click here to view the student\'s Student Diagnostic Results report.'
  },
  {
    element: '#objectiveResults',
    intro: 'See the student\'s Objective Pre and Posttest results. Students take an objective test before and after each objective. There are six objectives in WordFlight.'
  },
  {
    element: '#assessments-button',
    intro: 'Click here to view the student\'s Objective Pre/Post report.'
  }
];
